var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import { useTheme } from 'styled-components';
import React from 'react';
import { Button } from '../../atoms/Button';
import { Spacing } from '../../../components/Spacing';
import { HeadlineChooser, Paragraph } from '../../atoms/Typography';
import { useMedia } from '../../../hooks/useMedia';
import { CTARow } from '../../helpers/CTARow';
import { MediaCopyView } from './components/MediaCopyView';
export const MediaCopy = (_a) => {
    var { children, actions, headline, text, isContentCentered } = _a, props = __rest(_a, ["children", "actions", "headline", "text", "isContentCentered"]);
    const theme = useTheme();
    const isMobile = useMedia({ maxWidth: theme.screenTabletL });
    const isCentered = isContentCentered !== null && isContentCentered !== void 0 ? isContentCentered : isMobile;
    return (React.createElement(MediaCopyView, Object.assign({ isContentCentered: isCentered }, props),
        (headline === null || headline === void 0 ? void 0 : headline.children) && (React.createElement(Spacing, { mb: "spacing-xs" },
            React.createElement(HeadlineChooser, Object.assign({ "data-testid": `mediaCopy__Headline--${headline.variant}`, align: isCentered ? 'center' : undefined }, headline)))),
        (text === null || text === void 0 ? void 0 : text.children) && (React.createElement(Spacing, { mb: "spacing-m" },
            React.createElement(Paragraph, Object.assign({ align: isCentered ? 'center' : undefined }, text)))),
        children,
        actions && (React.createElement(CTARow, { flexDirection: isCentered ? 'column' : 'row' }, Object.entries(actions).map(([variant, { url, text, onClick, dataTestId }], i) => {
            return url && text ? (React.createElement(Button, { key: `${i}-${text}`, variant: variant, as: "a", href: url, onClick: onClick, "data-testid": dataTestId }, text)) : null;
        })))));
};
